export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_hu.47c1cfab11f3d193.json"